import React, { createRef } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../Shared/Icon/Icon'

const Search = ({
  aggregates, onStatusChange, onFormSubmit, selectedStatus,
}) => {
  const onSubmit = e => {
    e.preventDefault()

    return onFormSubmit(input.current.value)
  }

  const className = (value) => {
    return `section__item ${(selectedStatus === value ? ' is-active' : '')}`
  }

  const input = createRef()

  return (
    <div className="conversations-search__section">
      <ul className="list list--inline list--conversation-types">
        <li value="active" className={className('active')} onClick={onStatusChange}>
          All ({aggregates.active})
        </li>
        <li value="unread" className={className('unread')} onClick={onStatusChange}>
          Unread ({aggregates.unread})
        </li>
        <li value="unanswered" className={className('unanswered')} onClick={onStatusChange}>
          Unanswered ({aggregates.unanswered})
        </li>
        <li value="archived" className={className('archived')} onClick={onStatusChange}>
          Archived ({aggregates.archived})
        </li>
      </ul>

      <div className="section__form-container">
        <form
          className="search-form conversations-search__form"
          onSubmit={onSubmit}
        >
          <Icon type="search" />
          <input
            autoComplete="off"
            className="conversations-search__field"
            placeholder="search conversations"
            type="search"
            ref={input}
          />
        </form>
      </div>
    </div>
  )
}

Search.propTypes = {
  aggregates: PropTypes.shape({
    active: PropTypes.number.isRequired,
    unread: PropTypes.number.isRequired,
    unanswered: PropTypes.number.isRequired,
    archived: PropTypes.number.isRequired,
  }).isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  selectedStatus: PropTypes.string,
}

Search.defaultPropTypes = {
  selectedStatus: 'active',
}

export default Search
